import request from "@/utils/request";

export function registerVerify(params) {
  return request.post('/register/verify', params, { login: false });
}
export function register(params) {
  return request.post('/register', params, { login: false });
}
export function restPass(data) {
  return request.post('/password/reset', data, { login: false });
}
export function updatePass(data) {
  return request.post('/register/reset', data, { login: false });
}
/*
 * 验证码登录
*/
export function vermobileLogin(data) {
  return request.post('/login/mobile', data, {login: false});
}
export function login(params) {
  return request.post('/login', params, { login: false });
}

export function authLogout(params) {
  return request.post('/auth/logout', params, { login: false });
}
export function authLogin(params) {
  return request.get('/wechat/auth', params, { login: false });
}

/*
 * 隐私政策 用户协议
*/
export function privacyPolicy (id){
  return request.get('/privacyPolicy/details/'+id,{}, { login: false });
}
